import { ChangeEvent, FC, useEffect, useState } from 'react';
import { StyledContainer, StyledLabel, StyledRadioGroup } from './RadioGroup.styles';
import { RadioGroupDirection, RadioGroupProps } from './RadioGroup.types';
import RadioGroupContext from './RadioGroupContext';

const RadioGroup: FC<RadioGroupProps> = (props) => {
  const { css, children, defaultValue, direction, disabled, id, labelStyles, name, onChange, label, reset } = props;
  const [radioValue, setRadioValue] = useState(defaultValue);

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setRadioValue(event.target?.value);

    if (onChange != null) {
      onChange(event, event.target?.value);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    if (disabled || reset) setRadioValue(defaultValue);
  }, [disabled, reset]);

  const labelId = `${id}-label`;

  return (
    <RadioGroupContext.Provider value={{ disabled, name, onChange: handleChange, value: radioValue }}>
      <StyledContainer css={css}>
        {label && (
          <StyledLabel css={labelStyles} disabled={disabled} id={labelId}>
            {label}
          </StyledLabel>
        )}
        <StyledRadioGroup role="radiogroup" aria-labelledby={labelId} direction={direction} aria-activedescendant="">
          {children}
        </StyledRadioGroup>
      </StyledContainer>
    </RadioGroupContext.Provider>
  );
};

RadioGroup.defaultProps = {
  direction: RadioGroupDirection.ROW,
};

export default RadioGroup;
